import { BrowserType, MenuButtonEnum } from '../../constants.js'

const objFunc = () => {
  return {
    sidebarOpen: false,
    multipleAccounts: false,
    header: {
      text: '',
      buttonType: MenuButtonEnum.none
    },
    ariaHeader: '',
    showAllLoansToggle: false,
    showAllLoans: true,
    allowScroll: true,
    preventHeaderClick: false,

    /**
     * If the device/browser info has already been set, this prevents it being run again.
     */
    hasSetDeviceBrowser: false,

    /**
     * The built-in Chrome/Edge PWA installation prompt action. Use this to trigger the install prompt again.
     */
    pwaDeferredPrompt: undefined,

    isMobileBrowser: false,

    mobileOs: false,

    desktopOs: false,

    browserType: BrowserType.Unknown,

    /**
     * This is supported by most Chromium based browsers (Chrome, Edge, Samsung Browser, etc.).
     */
    supportsPwaPrompt: false,

    isPwa: false
  }
}

export default objFunc()

export const defaultObj = objFunc()
